export default __webpack_public_path__ + "static/media/tech.f27701a8.jpg";